// extracted by mini-css-extract-plugin
export default {"container":"RolesInnerLayout2_container__jRndQ"};